export default __webpack_public_path__ + "static/media/megaphone.78e039b3.svg";